<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3.284926,3.7552946622657775C2.767279,3.7552946622657775,2.34375,4.178824662265777,2.34375,4.696474662265778C2.34375,4.696474662265778,2.34375,15.049364662265777,2.34375,15.049364662265777C2.34375,15.567064662265778,2.767279,15.990564662265777,3.284926,15.990564662265777C3.8025700000000002,15.990564662265777,4.2261,15.567064662265778,4.2261,15.049364662265777C4.2261,15.049364662265777,4.2261,4.696474662265778,4.2261,4.696474662265778C4.2261,4.178824662265777,3.8025700000000002,3.7552946622657775,3.284926,3.7552946622657775C3.284926,3.7552946622657775,3.284926,3.7552946622657775,3.284926,3.7552946622657775ZM3.284926,0.9317646622657776C2.767279,0.9317646622657776,2.34375,1.3552936622657776,2.34375,1.8729406622657776C2.34375,2.390584662265778,2.767279,2.8141146622657773,3.284926,2.8141146622657773C3.8025700000000002,2.8141146622657773,4.2261,2.390584662265778,4.2261,1.8729406622657776C4.2261,1.3552936622657776,3.8025700000000002,0.9317646622657776,3.284926,0.9317646622657776C3.284926,0.9317646622657776,3.284926,0.9317646622657776,3.284926,0.9317646622657776ZM5.16728,3.7835246622657777C5.16728,3.7835246622657777,5.16728,10.588234662265778,5.16728,10.588234662265778C7.11551,8.602354662265778,10.73904,12.235264662265777,13.63785,10.588234662265778C13.63785,10.588234662265778,13.63785,3.7835246622657777,13.63785,3.7835246622657777C10.81434,5.731764662265777,7.1061,1.8729406622657776,5.16728,3.7835246622657777C5.16728,3.7835246622657777,5.16728,3.7835246622657777,5.16728,3.7835246622657777Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Flag',
} as DefineComponent
</script>
